import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { IDynamoUser } from '../shared/interfaces/user';

@Injectable({
  providedIn: 'root'
})
export class UsersManagementService {

  private _refreshUsers$ = new Subject<void>();

  constructor(private http: HttpClient) { }

  get refreshUsers$() {
    return this._refreshUsers$;
  }

  public getUsersByCorporation(): Observable<IDynamoUser[]> {
    return this.http.get<IDynamoUser[]>(`${environment.dataToolsUrl}/usermanagement/corpuser/list`);
  }

  public insertUserInDynamo(user: IDynamoUser): Observable<any> {
    return this.http.post(`${environment.dataToolsUrl}/usermanagement/corpuser/add`, user)
      .pipe(
        tap(() => {
          this._refreshUsers$.next();
        })
      );
  }

  public deleteUserInDynamo(userId: number): Observable<any> {
    return this.http.delete(`${environment.dataToolsUrl}/usermanagement/corpuser/${userId}`)
      .pipe(
        tap(() => {
          this._refreshUsers$.next();
        })
      );
  }

}
